import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { B2BProvider } from "@modules/content/B2BContext";

import { DarkModeProvider } from "./modules/theme/DarkModeContext";
import { LanguageProvider } from "./modules/localizations/LanguageContext";
import App from "./App";
import useCachedResources from "./utils/hooks/useCachedResources";
import { setupInterceptors } from "./modules/api/util/setupInterceptors";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "@components/items/display/ErrorFallback";

const clientId =
  "28055906188-mp0vnuc1rvpdahh4eon01i9top95911t.apps.googleusercontent.com";

setupInterceptors();

export function Entry() {
  const isLoadingComplete = useCachedResources();

  if (!isLoadingComplete) return null;

  return (
    <LanguageProvider>
      <DarkModeProvider>
        <ErrorWrapper>
          <BrowserRouter>
            <GoogleOAuthProvider clientId={clientId}>
              <B2BProvider>
                <App />
              </B2BProvider>
            </GoogleOAuthProvider>
          </BrowserRouter>
        </ErrorWrapper>
      </DarkModeProvider>
    </LanguageProvider>
  );
}

const ErrorWrapper = ({ children }: { children: JSX.Element }) => {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={(details) => {
        window.location.href = "https://wajeez.com/contact-us";
      }}
    >
      {children}
    </ErrorBoundary>
  );
};

export default Entry;
